<template>
  <div id="reset-password">
    <div class="row">
      <div class="title col-12">{{$t('resetPassword.modal.title')}}</div>
    </div>
    <div class="row input-row">
      <base-input
        @baseInputValue="emailChanged($event)"
        @enter="resetPasswordClicked"
        :placeHolder="$t('resetPassword.modal.email.placeholder')"
        :isInvalid="!isEmailValid && email != null"
        :errorText="$t('resetPassword.modal.email.errorText')"
        class="email-input"
      />
    </div>
    <div class="row">
      <base-button
        @click="resetPasswordClicked"
        :text="$t('resetPassword.modal.buttonText')"
        class="col-12"
      />
    </div>
    <div class="row">
      <div class="col-12 cancel-row">
        <span class="cancel" @click="cancel">{{$t('resetPassword.modal.cancelText')}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import BaseInput from '@/components/shared/elements/BaseInput';
import BaseButton from '@/components/shared/elements/BaseButton';
import RegistrationFormMixin from '@/components/shared/users/RegistrationFormMixin';

export default {
  name: 'ResetPasswordModal',
  mixins: [RegistrationFormMixin],
  components: {
    BaseInput,
    BaseButton,
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions({
      generatePasswordReset: 'users/generatePasswordReset',
    }),
    resetPasswordClicked() {
      if (!this.isEmailValid) {
        return;
      }
      this.generatePasswordReset(this.email)
        .then(() => {
          this.$eventBus.closeModal();
          this.$swal(
            this.$t('resetPassword.modal.success.title'),
            this.$t('resetPassword.modal.success.message'),
            'success',
          );
        })
        .catch(() => {
          this.$eventBus.closeModal();
          this.$swal(
            this.$t('resetPassword.modal.error.title'),
            this.$t('resetPassword.modal.error.message'),
            'error',
          );
        });
    },
    cancel() {
      this.$eventBus.closeModal();
    },
  },
};
</script>

<style lang="scss" scoped>
#reset-password {
  min-width: 500px;
  padding: 20px;
  .input-row {
    height: 70px;
    margin-top: 20px;
  }
  .cancel-row {
    margin-top: 10px;
    .cancel {
      margin: 0px auto;
      cursor: pointer;
      color: $primary-color;
      &:hover {
        color: $secondary-color;
      }
    }
  }
}
</style>
